import React, { useState } from "react";
import { Link } from "react-router-dom";
const AdministratieMenu = ({ token, username, isActive, onToggle }) => {
  const [submenuStates, setSubmenuStates] = useState({
    systeem: false,
    integraties: false,
    beveiliging: false,
    sensors: false
  });

  const toggleSubmenu = (key) => {
    setSubmenuStates(prev => {
      // Sluit alle submenus en open alleen de geselecteerde
      const newState = {
        systeem: false,
        integraties: false,
        beveiliging: false,
        sensors: false
      };
      // Toggle de geselecteerde submenu (als het al open is, sluit het)
      newState[key] = !prev[key];
      return newState;
    });
  };
  if (token.role === "admin") {
    return (
      <React.Fragment>
 
        <div className="menu-header">Admin Functies</div>
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-book"></i>
            </span>
            <span className="menu-text">Administratie</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>

            {/* Systeem Beheer */}
            <div className="menu-item">
              <div className="menu-link" onClick={() => toggleSubmenu('systeem')}>
                <span className="menu-icon">
                  <i className="fas fa-cogs"></i>
                </span>
                <span className="menu-text">Systeem Beheer</span>
                <span className={`menu-arrow ${submenuStates.systeem ? "rotate" : ""}`}>
                  <i className="fas fa-chevron-right"></i>
                </span>
              </div>
              <div className={`menu-sub ${submenuStates.systeem ? "show" : ""}`}>
                <div className="menu-item">
                  <Link to="/admin/bedrijven" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-book"></i>
                    </span>
                    <span className="menu-text">Bedrijven</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/gebruikers/" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-users"></i>
                    </span>
                    <span className="menu-text">Gebruikers</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/userorganisaties" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-sitemap"></i>
                    </span>
                    <span className="menu-text">Partner-organisaties</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/upgrade" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-arrow-up"></i>
                    </span>
                    <span className="menu-text">Upgrade</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Integraties */}
            <div className="menu-item">
              <div className="menu-link" onClick={() => toggleSubmenu('integraties')}>
                <span className="menu-icon">
                  <i className="fas fa-plug"></i>
                </span>
                <span className="menu-text">Integraties</span>
                <span className={`menu-arrow ${submenuStates.integraties ? "rotate" : ""}`}>
                  <i className="fas fa-chevron-right"></i>
                </span>
              </div>
              <div className={`menu-sub ${submenuStates.integraties ? "show" : ""}`}>
                <div className="menu-item">
                  <Link to="/admin/connections/" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-plug"></i>
                    </span>
                    <span className="menu-text">Connections</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/reserveringssystemen" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-calendar-alt"></i>
                    </span>
                    <span className="menu-text">Reserveringssystemen</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/betaalmethodes" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-credit-card"></i>
                    </span>
                    <span className="menu-text">Betaalmethodes</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/toegangscontrole" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-lock"></i>
                    </span>
                    <span className="menu-text">Toegangscontrole</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Beveiliging */}
            <div className="menu-item">
              <div className="menu-link" onClick={() => toggleSubmenu('beveiliging')}>
                <span className="menu-icon">
                  <i className="fas fa-shield-alt"></i>
                </span>
                <span className="menu-text">Beveiliging</span>
                <span className={`menu-arrow ${submenuStates.beveiliging ? "rotate" : ""}`}>
                  <i className="fas fa-chevron-right"></i>
                </span>
              </div>
              <div className={`menu-sub ${submenuStates.beveiliging ? "show" : ""}`}>
                <div className="menu-item">
                  <Link to="/admin/apikeys" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-key"></i>
                    </span>
                    <span className="menu-text">API Keys</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/login-attempts" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-shield-alt"></i>
                    </span>
                    <span className="menu-text">Login Attempts</span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Sensor Management */}
            <div className="menu-item">
              <div className="menu-link" onClick={() => toggleSubmenu('sensors')}>
                <span className="menu-icon">
                  <i className="fas fa-project-diagram"></i>
                </span>
                <span className="menu-text">Sensor Beheer</span>
                <span className={`menu-arrow ${submenuStates.sensors ? "rotate" : ""}`}>
                  <i className="fas fa-chevron-right"></i>
                </span>
              </div>
              <div className={`menu-sub ${submenuStates.sensors ? "show" : ""}`}>
                <div className="menu-item">
                  <Link to="/admin/sensoren/" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-search"></i>
                    </span>
                    <span className="menu-text">Sensoren</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/rapportage" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-chart-simple"></i>
                    </span>
                    <span className="menu-text">Sensoren rapportage</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/map" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-map"></i>
                    </span>
                    <span className="menu-text">Sensoren op kaart</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/sensor/toevoegen" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-plus"></i>
                    </span>
                    <span className="menu-text">Sensor toevoegen</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/alertprofile" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-edit"></i>
                    </span>
                    <span className="menu-text">Notificatie instellingen</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/instellingen" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-gear"></i>
                    </span>
                    <span className="menu-text">Sensor Instellingen</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/sensor/importeren" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-upload"></i>
                    </span>
                    <span className="menu-text">CSV Importeren</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/sensor/chirpstack-import" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-cloud-download"></i>
                    </span>
                    <span className="menu-text">ChirpStack Devices Import</span>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/admin/sensoren/sensor/chirpstack-application-logs" className="menu-link">
                    <span className="menu-icon">
                      <i className="fa fa-list-alt"></i>
                    </span>
                    <span className="menu-text">ChirpStack Logs (Application)</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  } else {
    return null;
  }
};
export default AdministratieMenu;
